export default __webpack_public_path__ + "static/media/sort_icon.0bac966f.svg";